import "../../../react-focus-lock/dist/es2015/sidecar.js";
import "../../node_modules/react-remove-scroll/dist/es2015/sidecar.js";
import { Effect as r } from "./Effect.js";
import { effectCar as o } from "./medium.js";
import { exportSidecar as t } from "../../../use-sidecar/dist/es2015/exports.js";
const a = t(o, r);
export {
  a as default
};
//# sourceMappingURL=sidecar.js.map
